var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutusImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 463,
    viewBox: "0 0 301 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.165 92.5301C395.159 115.247 421.415 169.685 438.998 214.074C456.013 257.03 431.868 290.67 417.903 334.712C402.797 382.352 407.075 433.689 359.012 447.389C312.974 460.512 311.335 376.656 268.56 355.161C231.641 336.608 153.648 366.415 130.194 332.399C100.618 289.506 44.7655 216.117 58.3993 165.831C73.0352 111.849 164.257 147.43 216.881 128.485C267.103 110.405 306.217 67.133 353.165 92.5301Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.001 108.835C386.858 129.315 410.529 178.39 426.381 218.407C441.72 257.131 419.954 287.457 407.365 327.16C393.747 370.107 397.605 416.386 354.275 428.736C312.771 440.566 311.293 364.971 272.731 345.593C239.448 328.867 169.137 355.738 147.992 325.072C121.329 286.404 70.9768 220.245 83.2673 174.912C96.4612 126.248 178.699 158.325 226.14 141.247C271.415 124.948 306.677 85.9396 349.001 108.835Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.882 119.496C380.882 138.429 402.768 183.793 417.424 220.783C431.608 256.579 411.487 284.611 399.851 321.31C387.264 361.007 390.833 403.786 350.776 415.199C312.408 426.132 311.037 356.255 275.386 338.34C244.616 322.878 179.617 347.712 160.068 319.365C135.416 283.62 88.8627 222.462 100.222 180.56C112.417 135.577 188.445 165.233 232.303 149.449C274.157 134.386 306.754 98.3298 345.882 119.496Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.149 133.06C370.069 149.241 388.788 187.992 401.325 219.59C413.458 250.168 396.269 274.103 386.334 305.444C375.587 339.346 378.65 375.885 344.417 385.621C311.627 394.948 310.435 335.266 279.96 319.955C253.657 306.739 198.109 327.931 181.392 303.715C160.312 273.178 120.506 220.93 130.203 185.144C140.613 146.728 205.602 172.079 243.082 158.61C278.851 145.757 306.7 114.971 340.149 133.06Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.581 144.492C367.831 159.233 384.869 194.558 396.279 223.363C407.32 251.238 391.652 273.068 382.589 301.648C372.787 332.562 375.563 365.876 344.374 374.766C314.499 383.282 313.436 328.867 285.679 314.918C261.722 302.879 211.112 322.222 195.892 300.148C176.7 272.314 140.457 224.691 149.305 192.059C158.802 157.029 217.997 180.118 252.145 167.824C284.735 156.091 310.117 128.011 340.581 144.492Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.856 158.221C360.612 171.073 375.462 201.879 385.405 226.998C395.028 251.307 381.365 270.347 373.461 295.273C364.91 322.235 367.326 351.287 340.134 359.044C314.086 366.475 313.166 319.019 288.968 306.858C268.083 296.361 223.956 313.237 210.69 293.988C193.961 269.716 162.369 228.188 170.086 199.729C178.371 169.178 229.977 189.306 259.751 178.58C288.165 168.344 310.298 143.852 336.856 158.221Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.747 166.784C358.406 178.503 371.944 206.597 381.008 229.505C389.779 251.674 377.32 269.04 370.11 291.773C362.311 316.364 364.511 342.86 339.715 349.937C315.965 356.717 315.13 313.437 293.068 302.348C274.026 292.777 233.789 308.172 221.694 290.618C206.443 268.484 177.641 230.613 184.681 204.657C192.239 176.793 239.291 195.145 266.44 185.36C292.349 176.021 312.532 153.682 336.747 166.784Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.183 192.756C347.428 201.004 356.957 220.772 363.338 236.891C369.513 252.489 360.746 264.707 355.673 280.702C350.187 298.003 351.737 316.646 334.287 321.624C317.573 326.392 316.982 295.94 301.454 288.136C288.052 281.4 259.735 292.229 251.222 279.877C240.487 264.302 220.213 237.653 225.166 219.391C230.482 199.786 257.569 200.316 276.675 193.433C294.909 186.865 315.14 183.535 332.183 192.756Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.263 204.262C341.521 210.887 349.196 226.742 354.339 239.67C359.315 252.18 355.952 263.582 348.221 274.783C344.935 277.731 344.691 278.335 337.979 280.238C324.552 284.044 317.144 286.962 304.659 280.691C293.884 275.279 271.14 283.933 264.287 274.024C255.647 261.528 239.331 240.148 243.294 225.513C247.547 209.802 269.314 210.252 284.66 204.753C299.306 199.504 315.56 196.854 329.263 204.262Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.19 214.623C331.265 219.515 336.979 231.165 340.813 240.661C344.523 249.85 342.068 258.205 336.384 266.401C333.964 268.554 333.785 268.997 328.83 270.375C318.918 273.132 313.452 275.252 304.209 270.62C296.232 266.622 279.448 272.91 274.359 265.624C267.94 256.435 255.828 240.709 258.717 229.985C261.819 218.473 277.905 218.86 289.231 214.866C300.04 211.055 312.044 209.154 322.19 214.623Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.06 224.143C320.468 227.054 323.882 233.969 326.175 239.604C328.394 245.058 326.942 250.01 323.567 254.864C322.128 256.139 322.023 256.401 319.074 257.213C313.177 258.837 308.768 262.185 305.489 261.936C302.211 261.686 301.449 264.694 286.642 254.335C282.811 248.879 275.583 239.54 277.292 233.183C279.126 226.359 288.702 226.607 295.44 224.251C301.871 222.002 309.015 220.888 315.06 224.143Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.333 229.137C316.26 231.25 318.742 236.266 320.41 240.353C322.023 244.308 323.404 248.796 318.523 251.415C317.479 252.338 317.403 252.528 315.263 253.116C310.982 254.29 307.783 256.716 305.402 256.534C303.022 256.351 297.879 257.758 291.715 251.014C288.932 247.057 283.68 240.282 284.917 235.674C286.246 230.728 293.198 230.911 298.089 229.206C302.756 227.579 307.942 226.775 312.333 229.137Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutusImg);
export default __webpack_public_path__ + "static/media/Aboutus-img.e7adb789ed05c856599fde020f3515e7.svg";
export { ForwardRef as ReactComponent };